import { Breadcrumb } from '@components/breadcrumb';
import { ContactForm } from '@components/contactForm';
import { useFragment } from 'react-relay';
import { contactPageFragment } from './lib';
import type { ContactPagePropsType } from './types';

export const ContactPage: React.FC<ContactPagePropsType> = (props) => {
  const page = useFragment(contactPageFragment, props.page);

  return (
    <div className="relative max-w-[820px] mx-auto [&_h1]:font-normal [&_h3]:font-serif [&_h3]:text-xl [&_h3]:leading-7 [&_h3]:text-black [&_h3]:font-normal max-[700px]:mx-[25px]">
      <Breadcrumb data={page.breadcrumbs} />
      <h1>{page.title}</h1>
      <ContactForm formPageId={page.id} contactForm={page.form} />
    </div>
  );
};
